import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import SchemaOrg from "@/components/base/SchemaOrg";
import { businessDetails } from "@/mocks/business";

const siteUrl =
  (import.meta.env.VITE_SITE_URL as string) || "https://tbm-lab.genaiweb.ai";

const businessPageSchema = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  name: "事業内容 | 株式会社TBM健康美容研究所",
  description:
    "株式会社TBM健康美容研究所が展開する9つの事業プロジェクトの一覧。教材・出版、新製品化、健康事業、サロン経営、コンサルティング、スクール・セミナー、総合美容検定、グローバルプロジェクトをご紹介します。",
  url: `${siteUrl}/business`,
  publisher: {
    "@type": "Organization",
    name: "株式会社TBM健康美容研究所",
    url: siteUrl,
  },
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "ホーム",
      item: `${siteUrl}/`,
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "事業内容",
      item: `${siteUrl}/business`,
    },
  ],
};

export default function BusinessPage() {
  return (
    <div className="min-h-screen bg-white">
      <SchemaOrg data={businessPageSchema} />
      <SchemaOrg data={breadcrumbSchema} />
      <Header />

      <main>
        {/* Page Header */}
        <section className="relative w-full pt-24 md:pt-32 pb-12 md:pb-16 bg-gamo-light-gray">
          <div className="section-container">
            <nav className="flex items-center gap-2 text-xs text-gamo-medium-gray mb-6">
              <a href="/" className="hover:text-gamo-green transition-colors">
                ホーム
              </a>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-gamo-dark-gray">事業内容</span>
            </nav>
            <h1 className="text-gamo-black text-2xl md:text-3xl lg:text-4xl font-bold tracking-wide">
              事業内容
            </h1>
            <p className="text-gamo-medium-gray text-sm mt-3">
              Our Business
            </p>
            <p className="text-gamo-dark-gray text-sm md:text-base leading-relaxed max-w-3xl mt-5">
              株式会社TBM健康美容研究所は、教材・出版から新製品化、健康事業、サロン経営コンサルティング、
              スクール・セミナー、総合美容検定、グローバルプロジェクトまで、
              健康・美容トレンドを多角的にプロデュースする総合研究所です。
              9つの事業プロジェクトが連携し、美容業界の発展とプロフェッショナルの成長を支えています。
            </p>
            <div className="w-10 h-px bg-gamo-green mt-6" />
          </div>
        </section>

        {/* Business List */}
        <section className="w-full bg-white py-12 md:py-16">
          <div className="section-container">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {businessDetails.map((project) => (
                <a
                  key={project.slug}
                  href={`/business/${project.slug}`}
                  className="group flex flex-col bg-gamo-light-gray border border-gamo-border-gray rounded-lg overflow-hidden transition-all duration-300 hover:border-gamo-green"
                >
                  <div className="relative h-40 w-full overflow-hidden bg-gamo-light-gray">
                    <img
                      src={project.image}
                      alt={project.title}
                      title={`${project.title} | 株式会社TBM健康美容研究所`}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="flex flex-col flex-1 p-5 md:p-6">
                    <span className="text-gamo-green text-xs tracking-wider mb-2">
                      {project.category}
                    </span>
                    <h2 className="text-gamo-black text-base font-bold leading-snug mb-2">
                      {project.title}
                    </h2>
                    <p className="text-gamo-medium-gray text-sm leading-relaxed mb-4 line-clamp-3">
                      {project.description}
                    </p>
                    <span className="mt-auto inline-flex items-center gap-1 text-gamo-green text-sm font-medium">
                      <span>詳しく見る</span>
                      <i className="ri-arrow-right-line text-sm transition-transform duration-300 group-hover:translate-x-1"></i>
                    </span>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}